<template>
    <div class="animated revealUp">
        <div class="white-wrapper">
            <div class="section-title">
                View Voucher Usage
            </div>
            <div class="mt-3 mb-2">
                <div class="row">
                    <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                        <div class="input-material">
                            <div class="add-datepicker">
                                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                                <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="fromDate"
                                    v-validate="'required'"></Datepicker>
                                <label :class="fromDate ? 'active' : ''">
                                    <!-- {{ $t("show") }} -->
                                    {{ $t("fromdate") }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                        <div class="input-material">
                            <div class="add-datepicker">
                                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                                <Datepicker :monday-first="true" ref="programaticOpen" v-model="toDate"
                                    v-validate="'required'"></Datepicker>
                                <label :class="toDate ? 'active' : ''">
                                    <!-- {{ $t("show") }}  -->
                                    {{ $t("todate") }}</label>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-xl-2 align-self-center mb-3">
                        <button class="btn-blue-lg w-100" @click.prevent="getVoucherUseageV2()">
                            {{ $t("fetch") }}
                            {{ $t("report") }}
                        </button>
                    </div>

                    <div v-if="voucherUseageRecords.length > 0"
                        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-between align-items-center">
                        <div class="d-flex">
                            <p class="font-weight-bold mx-2">BO Redemptions: {{ boTicketsCount }}</p>
                            <p class="font-weight-bold mx-2">FnB Redemptions: {{ fnbTicketsCount }}</p>
                        </div>
                        <div>
                            <span class="mx-1">{{ $t("download") }} as:</span>
                            <!-- s -->

                            <!-- <a target="_blank" @click="getVoucherUseageV2('N', 'N')" title="Download as Pdf" download>
                                <img class="mx-1" src="@/assets/img/icons/pdf.svg" height="25" width="25"
                                    style="cursor:pointer;" />
                            </a> -->
                            <a target="_blank" @click="getVoucherUseageV2('N', 'Y')" title="Download as Excel" download>
                                <img class="mx-1" src="@/assets/img/icons/excel.svg" height="25" width="25"
                                    style="cursor:pointer;" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div style="overflow-x:scroll;width: auto !important" v-if="voucherUseageRecords.length > 0"
                ref="exportable_table">
                <table class="swc-report-table" border="1">
                    <thead class="bg-lightgrey font-weight-bold">
                        <th>{{ $t("voucher") }}</th>
                        <th>{{ $t("voucher") }} {{ $t("code") }}</th>
                        <th>{{ $t("Sales Channel") }}</th>
                        <th>{{ $tc("cinema", 1) }}</th>
                        <th>
                            {{ $tc("movie", 1) }} / {{ $tc("item") }} {{ $t("name") }}
                        </th>
                        <th>{{ $t("show") }} {{ $t("datetime") }}</th>
                        <th>{{ $t("time") }} {{ $t("usage") }}</th>
                        <!-- <th>{{ $t("client_name") }}</th> -->
                        <!-- <th>{{ $t("client") }} {{ $t("shareValue") }}</th> -->
                        <th>{{ $t("discount") }} {{ $t("amount") }}</th>
                        <th>{{ $t("grossAmount") }}</th>
                        <th>{{ $t("transaction_id") }}</th>
                        <th>{{ $t("comment") }}</th>
                        <th>{{ "User Name" }}</th>
                        <th>{{ "Customer Email" }}</th>
                        <th>{{ "Customer Mobile" }}</th>
                    </thead>
                    <tbody v-if="voucherUseageRecords.length">
                        <tr v-for="(voucherObj, voucherIndex) in voucherUseageRecords" :key="voucherIndex">
                            <td class="text-left">{{ voucherObj.voucher_name }}</td>
                            <td class="text-left">{{ voucherObj.used_voucher_code }}</td>
                            <td class="text-left">{{ voucherObj.sales_channel }}</td>
                            <td class="text-left">{{ voucherObj.cinema_name }}</td>
                            <td class="text-left break_text_spaces">{{ voucherObj.movie_item_name }}</td>
                            <td class="text-left">{{ voucherObj.show_date }}</td>
                            <td class="text-left">{{ voucherObj.booking_time }}</td>
                            <td class="text-right">{{ currFormat(voucherObj.discount_price) }}</td>
                            <td class="text-right">{{ currFormat(voucherObj.gross_amount) }}</td>
                            <td class="text-left">{{ voucherObj.booking_code }}</td>
                            <td class="text-left">{{ voucherObj.remark }}</td>
                            <td class="text-left">{{ voucherObj.user_name }}</td>
                            <td class="text-left">{{ voucherObj.cust_email || "-" }}</td>
                            <td class="text-left">{{ voucherObj.cust_mobile || "-" }}</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="11">
                                <NoRecords />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import MarketingService from "@/services/MarketingService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
    components: {
        NoRecords,
    },
    data() {
        return {
            BASEURL,
            isRoleID: false,
            submitted: false,
            dropDown: {
                cinemas: [],
                selectedCinema: null,
                selectedCinemaName: null,
                selectedCinemaId: "",
            },
            fromDate: new Date(),
            toDate: new Date(),
            voucherUseageRecords: [],
            fnbTicketsCount: 0,
            boTicketsCount: 0,
            excelFilePath: "",
            grandTotal: {},
        };
    },
    beforeMount() {
        let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
        // this.getCinemaList();
        const { voucher_id } = this.$route.query
        if (voucher_id) {
            this.getVoucherUseageV2()
        }
        // if (CinemaObj) {
        //   this.onSelectCinema(CinemaObj);
        // }
    },
    watch: {
        // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
        //   if (CinemaObj) {
        //     this.onSelectCinema(CinemaObj);
        //   }
        // },
    },
    mounted() { },
    methods: {
        moment,
        getCinemaList: function () {
            MasterService.GetCinemas()
                .then((response) => {
                    const { data } = response;
                    if (data.status && data.Records.length > 0) {
                        this.dropDown.cinemas = data.Records;
                        this.CinemasCopy = data.Records;
                    } else {
                        this.$toasted.show(data.message);
                    }
                })
                .catch(this._CatchError);
        },
        onSelectCinema: function (event) {
            this.dropDown.selectedCinema = event;
            this.dropDown.selectedCinemaName = event.cine_name;
            this.dropDown.selectedCinemaId = event.cine_id;
            this.$store.dispatch("selectDropdownCinema", event);
        },
        getVoucherUseageV2(isPdf = "N", isExcel = "N") {
            if (isExcel == "N") {
                this.voucherUseageRecords = [];
            }
            const { voucher_id } = this.$route.query;

            let loader = this.$loading.show();
            let payload = {
                fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
                toDate: moment(this.toDate).format("YYYY-MM-DD"),
                voucher_id,
                isExcel,
                isPdf
            };

            MarketingService.getVoucherUseage(payload)
                .then((response) => {
                    const { data } = response;
                    if (data.status && data.Records.length > 0) {
                        this.voucherUseageRecords = [...data.Records];
                        this.fnbTicketsCount = data.Records.filter(fnbObj => { return fnbObj.fnb_transaction_id }).length
                        this.boTicketsCount = data.Records.filter(fnbObj => { return fnbObj.sb_id }).length
                        if (isExcel == "Y" && data.excelPath) {
                            window.open(data.excelPath, "_blank");
                        }
                        if (isPdf == "Y" && data.pdfPath) {
                            window.open(data.pdfPath, "_blank");
                        }
                        this.$toasted.show(data.message);
                    } else {
                        this.$toasted.show(data.message);
                    }
                    loader.hide();
                })
                .catch(this._CatchError)
                .finally(() => {
                    setTimeout(() => {
                        loader.hide();
                    }, 100);
                });
        },
    },
};
</script>

<style scoped>
.concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
}

.concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
}

.concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
}

.concession-analysis-table tbody {
    border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
}

.gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
}

.swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid black;
}

.swc-report-table td {
    white-space: nowrap;
}

.swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
}

.swc_table_header th {
    border: 1px solid black !important;
}

.no_border {
    border: 0px !important;
}

.break_text_spaces {
    white-space: break-spaces;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/VouchersV2/getVoucherUseageV2.vue